import Container from '@components/Layout/Container'
import is from '@whitecobalt/tungsten/utils/is'
import React from 'react'
import Row from '@components/Layout/Row'
import Image from '@whitecobalt/tungsten/Image'
import { useSession } from '@whitecobalt/tungsten/Session'
import './index.scss'
export interface HalspanContainerProps extends Omit<React.HTMLProps<HTMLDivElement>, 'title'> {
    id: string;
    title?: string | React.ReactNode;
    // showCompanyLogo?: boolean;
    containerClassName?: string;
    bannerBackground?: string;
    bannerRaw?: React.ReactNode;
}

const HalspanContainer: React.FunctionComponent<HalspanContainerProps> = ({ id, title, containerClassName, bannerRaw, children, bannerBackground = '/images/verified-portal.png', ...props }) => {
    const [{user}] = useSession()
    
    return (
        <div id={id}>
            <div className="halspan-banner" style={{backgroundImage: `url(${bannerBackground})`}}>
                <Container fluid>
                    {bannerRaw || (
                        <>
                            <div className="halspan-banner-ribbon">
                                {is.str(title) ? <h1 className="title">{title}</h1> : title}
                            </div>
                            {/* {(showCompanyLogo && (user?.organisationIDs || []).length > 0 && user?.organisations[organisationIndex]?.companyLogoURL) && (
                                <div>
                                    <Image className="halspan-banner-logo" src={user?.organisations[organisationIndex].companyLogoURL} alt="org-logo" transparent/>
                                </div>
                            )} */}
                        </>
                    )}
                </Container>
            </div>
            <div className="halspan-main-container" {...props}>
                <Row>
                    {children}
                </Row>
            </div>
        </div>
    )
}

export default HalspanContainer
